import { ConstantTypes } from "./SEBulkShipment.types";

const constants: ConstantTypes =  {
    fileType: 'excel',
    headerTxt: 'Upload an excel file to upload shipment(s).',
    isMultiple: false,
    accept: '.xlsx, .xls',
    linkInfoText: 'Download sample file'
};

export default constants;
